import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) =>
  new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const VAT_RATES = [0, 6, 21];

export const RATE_CODES = ["E", "0", "6", "21"];
export const RATE_LABELS = { "E": "Tabak (0%)", "0": "Lotto (0%)", "6": "Voeding | Tijdschriften (6%)", "21": "Alcohol | E-Cigarettes (21%)" };
export const CATEGORY_TO_BUCKET = {
  lotto: "0", kranten: "0", voeding_tijdschriften: "6", alcohol_ecig: "21", tabak: "E",
};
